import type { ReactElement, ReactNode, Ref } from 'react';
import styles from './Section.module.css';

/**
 * Título da tela (h2). Recebe foco por código quando a pessoa troca de seção (a casca o procura por
 * `data-admin-heading`) e quando "Tentar de novo" dá certo e o botão some.
 */
export function SectionHeading({
  id,
  ref,
  children,
}: {
  id?: string;
  ref?: Ref<HTMLHeadingElement>;
  children: ReactNode;
}): ReactElement {
  return (
    <h2 id={id} ref={ref} tabIndex={-1} data-admin-heading="" className={styles.heading}>
      {children}
    </h2>
  );
}
